export const VENDOR_TYPE = {
    AZURE: 1,
    MIMI: 2,
};

export const SERVICE_TYPE = {
    ASR: 1,
    TRA: 2,
    LID: 3,
};

export const REQUEST_SOURCE_TYPE = {
    WEB: 1,
}
